<template>
    <div>
        <modal v-model="modal" class="skintestblock" :backdrop="false" size="lg">
            <h4 slot="title" class="smalltitle">Ticket for {{ detailTicket.title }}</h4>
            <div class="modal-body">
                <div class="event-single event-ticket">
                    <ul class="smalllist event-desc-list">
                        <li class="title">{{ detailTicket.title }}</li>
                        <li>
                            <div><i class="fa fa-user"></i></div>
                            <div>
                                <strong>{{ detailTicket.fullName }}</strong>
                            </div>
                        </li>
                        <li>
                            <div><i class="fa fa-calendar-alt"></i></div>
                            <div>Start on <strong>{{formatFullTime(detailTicket.start_time)}}</strong> - End on <strong>{{formatFullTime(detailTicket.end_time)}}</strong>
                            </div>
                        </li>
                        <li>
                            <div><i class="fa fa-map-marker-alt"></i></div>
                            <div>
                                <a href="#" data-ng-click="initMapEvent(event)" title="View map">{{detailTicket.event_place}},
                                    {{detailTicket.event_street_number}},
                                    {{detailTicket.event_city}}, {{detailTicket.event_state}}
                                    {{detailTicket.event_zipcode}}</a>
                            </div>
                        </li>
                        <li v-if="detailTicket.total_ticket">
                            Ticket Price: <span
                                style="float: right;">{{formatStringToView(detailTicket.total_ticket)}}</span>
                        </li>
                        <li v-if="detailTicket.hotel">
                            Hotel: {{detailTicket.hotel}}
                            <span style="float: right;">{{formatStringToView(detailTicket.price_hotel)}}</span>
                            <p style="font-size: 13px; font-weight: normal; margin-left: 10px; margin-bottom: 0px !important;">
                                {{detailTicket.hotelAddress}}</p>
                            <span style="font-size: 13px; font-weight: normal; margin-left: 10px;">Room: {{detailTicket.room}}</span>
                        </li>
                        <li v-if="detailTicket.addition_title">{{detailTicket.addition_title}}
                            <span style="float: right;">{{formatStringToView(detailTicket.addition_amount)}}</span>
                        </li>
                        <li>
                            Total: <span
                                style="float: right;">{{formatStringToView(detailTicket.totalPrice)}}</span>
                        </li>
                        <li class="ticket-barcode1"><img style="height: 60px !important;"
                                                         :src="'data:image/png;base64,' + detailTicket.ticket_bar_code"
                                                         alt="Ticket barcode">
                            <div class="ticket-number"><span>{{detailTicket.ticket_code}}</span></div>
                        </li>
                        <li class="ticket-barcode2"><img
                                :src="'data:image/png;base64,' + detailTicket.ticket_qr_code"
                                alt="Ticket qrcode">
                            <p class="smallexplain">Don't fold the barcodes' area. Second barcode maybe
                                empty.</p></li>
                    </ul>
                </div>
            </div>

            <div slot="footer" class="chatformwrap">
                <button type="button" class="btn btn-default" @click.prevent="modal = false">Close</button>
            </div>
        </modal>
    </div>

</template>

<script>
import axios from '../../../client'
import Common from '../../mixins/Common'
import config from '../../../config'

const wikiUrl = config.wikiUrl
export default {
  name: 'DetailTicketEvent',
  mixins: [Common],
  props: {
    detailTicket: { required: true }
  },
  data () {
    return {
      modal: false
    }
  },
  mounted () {
    this.modal = true
    console.log('detailTicket', this.detailTicket)
  },
  methods: {

  },
  beforeDestroy () {

  },
  updated () {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }

  }
}
</script>

<style scoped>

</style>
